import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'ml',
  months: [
    'ജനുവരി',
    'ഫെബ്രുവരി',
    'മാർച്ച്',
    'ഏപ്രിൽ',
    'മെയ്',
    'ജൂൺ',
    'ജൂലൈ',
    'ഓഗസ്റ്റ്',
    'സെപ്‌റ്റംബർ',
    'ഒക്‌ടോബർ',
    'നവംബർ',
    'ഡിസംബർ',
  ],
  monthsShort: ['ജനു', 'ഫെബ്രു', 'മാര്‍', 'ഏപ്രി', 'മെയ്', 'ജൂണ്‍', 'ജൂലൈ', 'ഓഗ', 'സെപ്തം', 'ഒക്ടോ', 'നവം', 'ഡിസം'],
  weekdays: ['ഞായര്‍', 'തിങ്കള്‍', 'ചൊവ്വ', 'ബുധന്‍', 'വ്യാഴം', 'വെള്ളി', 'ശനി'],
  weekdaysMin: ['ഞാ', 'തി', 'ചൊ', 'ബു', 'വ്യാ', 'വെ', 'ശ'],
  weekdaysShort: ['ഞാ', 'തി', 'ചൊ', 'ബു', 'വ്യാ', 'വെ', 'ശ'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'D/M/YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd, D MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd, D MMMM HH:mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    'll-D': 'MMM YYYY',
    lll: 'D MMM YYYY h:mm A',
    'lll-Y': 'D MMM h:mm A',
    llll: 'ddd, D MMM YYYY h:mm A',
    'llll-Y': 'ddd, D MMM h:mm A',
    'll-Y+w': 'MMM D, ddd',
    'LT+to': 'HH:mm ([ജിഎംടി]Z)',
    'LLL+to': 'YYYY, MMMM D HH:mm ([ജിഎംടി]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM' },
  past: {
    y: { one: '%s വർഷം മുമ്പ്', other: '%s വർഷം മുമ്പ്' },
    M: { one: '%s മാസം മുമ്പ്', other: '%s മാസം മുമ്പ്' },
    w: { one: '%s ആഴ്ച മുമ്പ്', other: '%s ആഴ്ച മുമ്പ്' },
    d: { one: '%s ദിവസം മുമ്പ്', other: '%s ദിവസം മുമ്പ്' },
    h: { one: '%s മണിക്കൂർ മുമ്പ്', other: '%s മണിക്കൂർ മുമ്പ്' },
    m: { one: '%s മിനിറ്റ് മുമ്പ്', other: '%s മിനിറ്റ് മുമ്പ്' },
    s: { one: '%s സെക്കൻഡ് മുമ്പ്', other: '%s സെക്കൻഡ് മുമ്പ്' },
  },
  future: {
    y: { one: '%s വർഷത്തിൽ', other: '%s വർഷത്തിൽ' },
    M: { one: '%s മാസത്തിൽ', other: '%s മാസത്തിൽ' },
    w: { one: '%s ആഴ്ചയിൽ', other: '%s ആഴ്ചയിൽ' },
    d: { one: '%s ദിവസത്തിൽ', other: '%s ദിവസത്തിൽ' },
    h: { one: '%s മണിക്കൂറിൽ', other: '%s മണിക്കൂറിൽ' },
    m: { one: '%s മിനിറ്റിൽ', other: '%s മിനിറ്റിൽ' },
    s: { one: '%s സെക്കൻഡിൽ', other: '%s സെക്കൻഡിൽ' },
  },
  pastLong: {
    y: { one: '%s വർഷം മുമ്പ്', other: '%s വർഷം മുമ്പ്' },
    M: { one: '%s മാസം മുമ്പ്', other: '%s മാസം മുമ്പ്' },
    w: { one: '%s ആഴ്ച മുമ്പ്', other: '%s ആഴ്ച മുമ്പ്' },
    d: { one: '%s ദിവസം മുമ്പ്', other: '%s ദിവസം മുമ്പ്' },
    h: { one: '%s മണിക്കൂർ മുമ്പ്', other: '%s മണിക്കൂർ മുമ്പ്' },
    m: { one: '%s മിനിറ്റ് മുമ്പ്', other: '%s മിനിറ്റ് മുമ്പ്' },
    s: { one: '%s സെക്കൻഡ് മുമ്പ്', other: '%s സെക്കൻഡ് മുമ്പ്' },
  },
  futureLong: {
    y: { one: '%s വർഷത്തിൽ', other: '%s വർഷത്തിൽ' },
    M: { one: '%s മാസത്തിൽ', other: '%s മാസത്തിൽ' },
    w: { one: '%s ആഴ്ചയിൽ', other: '%s ആഴ്ചയിൽ' },
    d: { one: '%s ദിവസത്തിൽ', other: '%s ദിവസത്തിൽ' },
    h: { one: '%s മണിക്കൂറിൽ', other: '%s മണിക്കൂറിൽ' },
    m: { one: '%s മിനിറ്റിൽ', other: '%s മിനിറ്റിൽ' },
    s: { one: '%s സെക്കൻഡിൽ', other: '%s സെക്കൻഡിൽ' },
  },
  abbr: {
    y: { one: '%sവ.', other: '%sവ.' },
    M: { one: '%sമാ.', other: '%sമാ.' },
    w: { one: '%sആ.', other: '%sആ.' },
    d: { one: '%sദി.', other: '%sദി.' },
    h: { one: '%sമ.', other: '%sമ.' },
    m: { one: '%sമി.', other: '%sമി.' },
    s: { one: '%sസെ.', other: '%sസെ.' },
  },
  full: {
    y: { one: '%s വർഷം', other: '%s വർഷം' },
    M: { one: '%s മാസം', other: '%s മാസം' },
    w: { one: '%s ആഴ്ച', other: '%s ആഴ്ച' },
    d: { one: '%s ദിവസം', other: '%s ദിവസം' },
    h: { one: '%s മണിക്കൂർ', other: '%s മണിക്കൂർ' },
    m: { one: '%s മിനിറ്റ്', other: '%s മിനിറ്റ്' },
    s: { one: '%s സെക്കൻഡ്', other: '%s സെക്കൻഡ്' },
  },
  justNow: 'ഇപ്പോൾ',
  yesterday: 'ഇന്നലെ',
  today: 'ഇന്ന്',
  tomorrow: 'നാളെ',
  weekStart: 0,
  timeRange: '%$1s - %$2s',
  timeZone: '%$1s %$2s',
  timePref: {},
  timeRangeStyles: {
    yl: { start: 'YYYY, MMMM D', end: 'YYYY, MMMM D' },
    'yl-1': { start: 'MMMM D', end: 'YYYY, MMMM D' },
    ml: { start: 'MMMM D', end: 'MMMM D' },
    'ml-1': { start: 'YYYY MMMM D', end: 'D' },
    dl: { start: 'MMMM D', end: 'D' },
    y: { start: 'YYYY MMM D', end: 'YYYY MMM D' },
    'y-1': { start: 'YYYY MMM D', end: 'MMM D' },
    m: { start: 'MMM D', end: 'MMM D' },
    'm-1': { start: 'YYYY MMM D', end: 'D' },
    d: { start: 'MMM D', end: 'D' },
    Y: { start: 'YYYY MMM D, ddd', end: 'YYYY MMM D, ddd' },
    'Y-1': { start: 'YYYY MMM D, ddd', end: 'MMM D, ddd' },
    M: { start: 'MMM D, ddd', end: 'MMM D, ddd' },
    D: { start: 'MMM D, ddd', end: 'MMM D, ddd' },
    yt: { start: 'YYYY MMM D HH:mm', end: 'YYYY MMM D HH:mm' },
    mt: { start: 'MMM D HH:mm', end: 'MMM D HH:mm' },
    dt: { start: 'MMM D HH:mm', end: 'MMM D HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'YYYY MMM D HH:mm', end: 'YYYY MMM D HH:mm ([ജിഎംടി]Z)' },
    'mt+to': { start: 'MMM D HH:mm', end: 'MMM D HH:mm ([ജിഎംടി]Z)' },
    'dt+to': { start: 'MMM D HH:mm', end: 'MMM D HH:mm ([ജിഎംടി]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([ജിഎംടി]Z)' },
  },
};
const localeName: LocaleName = 'ml';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'AM';
    } else {
      return isLowerCase ? 'pm' : 'PM';
    }
  },
};
